import React from 'react';
import { Paper, Title, Stack, Anchor } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

/**
 * QuickLinksPanel Component
 * Provides quick access to important pages
 */
const QuickLinksPanel = () => {
  const navigate = useNavigate();

  const links = [
    { label: 'Competition Rules', path: '/competition-rules' },
    { label: 'FAQs', path: '/faq' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
    { label: 'Contact Support', path: '/contact' }
  ];

  return (
    <Paper
      radius="md"
      p="xl"
      withBorder
      style={{
        borderTop: '4px solid var(--primary-gold)'
      }}
    >
      <Title order={3} size="h4" mb="lg" style={{ color: 'var(--charcoal)' }}>
        Quick Links
      </Title>

      <Stack spacing="md">
        {links.map((link, index) => (
          <Anchor
            key={index}
            size="sm"
            onClick={() => navigate(link.path)}
            style={{
              color: 'var(--soft-gray)',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              cursor: 'pointer',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--primary-gold)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--soft-gray)'}
          >
            <span>•</span>
            <span>{link.label}</span>
          </Anchor>
        ))}
      </Stack>
    </Paper>
  );
};

export default QuickLinksPanel;
